import { withPlayerEyes } from './playerEyes';
import type { EyeStyleOptions } from './AppearanceDefinitions';

/**
 * The player ghost's look, applied at the player render boundary only
 * (PlayerRenderer and CharacterPortrait — so creator, roster, HUD frame,
 * social and equipment portraits all match the in-world sprite). NPC textures
 * never pass through here, so NPC art (plan 12) is untouched.
 *
 * - Eyes: two matching eyes by default (plan 12 §7, see playerEyes.ts).
 * - No feet (lane BC, DJ 2026-10-09): the ghost floats (lane BA), so the body's
 *   own wavy hem is its bottom edge. Boots keep their item, inventory and
 *   paperdoll slot but have no on-body visual.
 */
export function withPlayerLook<T extends { eyeStyle?: EyeStyleOptions; footless?: boolean }>(appearance: T): T {
  return { ...withPlayerEyes(appearance), footless: true };
}
